<ng-container *ngIf="articleData">
  <section class="section-about-hero">
    <div class="section-container">
      <div class="product-hero-content-box justfy-item-e">
        <div>
          <span class="product-hero-subheading grey-800 mar-b-16">
            {{ articleData.createdDate | date: 'longDate' }}
          </span>
          <p class="discover-power-subtext grey-800 mar-b-16">
            {{ articleData.author }}
          </p>
          <h1 class="product-hero-header grey-800">
            {{ articleData.header }}
          </h1>
        </div>
        <img
          src="{{ articleData.bannerimage.url }}"
          alt="{{ articleData.bannerimage.alt }}"
        />
      </div>
    </div>
  </section>
  <section class="section-white">
    <div class="section-container">
      <div class="blog-content">
        <div class="wys" [innerHtml]="articleData.richTextTop | toHtml"></div>
        <div
          class="grey-100 padd-32 mar-b-48 border-radius"
          *ngIf="articleData?.blogContentAdPanel?.header"
        >
          <h3 class="be-truly-heading mar-b-24">
            {{ articleData.blogContentAdPanel?.header }}
          </h3>
          <div class="ready-to-get-started-btn-wrapper">
            <a
              href="{{ articleData.blogContentAdPanel?.button?.url }}"
              target="{{ articleData.blogContentAdPanel?.button?.target }}"
              class="btn btn-full"
              >{{ articleData.blogContentAdPanel?.button?.text }}</a
            >
          </div>
        </div>
        <div>
          <div
            class="wys"
            [innerHtml]="articleData.richTextBottom | toHtml"
          ></div>
        </div>
        <div class="footer-social">
          <ul class="footer-social-links">
            <li>
              <p class="section-description align-l">
                <strong>Share this article </strong>
              </p>
            </li>
            <li>
              <a (click)="social('facebook')" class="social-icon" href="#">
                <img
                  src="./assets/images/ico-facebook.svg"
                  class="footer-social-icon"
                  alt="Facebook"
                />
              </a>
            </li>
            <li>
              <a (click)="social('twitter')" class="social-icon" href="#">
                <img
                  src="/assets/images/ico-twitter.svg"
                  class="footer-social-icon"
                  alt="Twitter"
                />
              </a>
            </li>
            <li>
              <a (click)="social('linkedin')" class="social-icon" href="#">
                <img
                  src="/assets/images/ico-linkedin.svg"
                  class="footer-social-icon"
                  alt="LinkedIn"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</ng-container>
